import { Button, styled } from '@ethings/ui-toolkit';
import cx from 'classnames';
import { FC, PropsWithChildren } from 'react';

interface MenuButtonProps extends PropsWithChildren {
  className?: string;
  'data-testid'?: string;
  disabled?: boolean;
}

export const MenuButton: FC<MenuButtonProps> = ({ className, ...props }) => {
  const StyledMenuButton = styled(Button)({ color: 'unset', textDecoration: 'unset', margin: 0, padding: 0, textTransform: 'unset', fontSize: 'unset' });
  return (
    <StyledMenuButton
      {...props}
      className={cx('MenuButton-root', className)}
    />
  );
};
